var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":"danger","loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" 删除 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }